import { render } from "./PolicyView.vue?vue&type=template&id=0e3eae46&scoped=true"
import script from "./PolicyView.vue?vue&type=script&lang=js"
export * from "./PolicyView.vue?vue&type=script&lang=js"

import "./PolicyView.vue?vue&type=style&index=0&id=0e3eae46&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3eae46"]])

export default __exports__